import React from "react";
import "../Hero.css";
import heroImg from "../../assets/hero-image.jfif";

import {
    FaArrowRight,
    FaArrowDown,
    FaCode,
    FaLaptopCode,
    FaMobileAlt,
    FaRobot,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Hero = () => {
    return (
        <section className="hero-section">

            <div className="container hero-wrapper">

                {/* LEFT */}
                <div className="hero-left">

                    <span className="hero-tag" style={{
                        display: "inline-block",
                        padding: "8px 20px",
                        borderRadius: "30px",
                        background: "#dbeafe",
                        color: "#2563eb",
                        fontWeight: 600,
                        marginBottom: "20px"
                    }}>
                        Software Development • AI • Cloud • Digital Transformation
                    </span>

                    <h1>
                        Building <span>Smart Digital Solutions</span> That
                        Transform Businesses
                    </h1>

                    <p>
                        VisionVote Technologies Private Limited is a modern software startup
                        delivering innovative web applications, mobile apps, AI-powered
                        solutions, cloud services, and enterprise software that help
                        businesses accelerate growth in the digital era.
                    </p>

                    <div className="hero-actions">

                        <button className="hero-btn-primary">
                    
                            Get Started
                            <FaArrowDown />
                        </button>

                        <button className="hero-btn-secondary" onClick={() => window.location.href = '/services'} style={{hover: { backgroundColor: "#2563eb", color: "#fff" }}}>
                        
                                Explore Services
                            <FaArrowRight style={{ marginLeft: "10px", marginTop: "4px", color: "#2563eb" }} />
                            
                        </button>

                    </div>

                </div>

                {/* RIGHT */}
                <div className="hero-right">

                    <img src={heroImg} alt="VisionVote Technologies" />

                    <div className="hero-card hero-card-1">
                        <FaLaptopCode />
                        <span>Web Development</span>
                    </div>

                    <div className="hero-card hero-card-2">
                        <FaMobileAlt />
                        <span>Mobile Applications</span>
                    </div>

                    <div className="hero-card hero-card-3">
                        <FaRobot />
                        <span>AI Solutions</span>
                    </div>

                    <div className="hero-card hero-card-4">
                        <FaCode />
                        <span>Custom Software</span>
                    </div>

                </div>

            </div>

        </section>
    );
};

export default Hero;